import { Outlet } from "react-router-dom";
import { CustomerSidebar } from "./CustomerSidebar";

export function CRMLayout() {
  return (
    <div className="flex h-screen overflow-hidden">
      <CustomerSidebar />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
